import api from "../api/programs";
import {createError, logError, logSuccess} from "./message";
import {getFullProgram} from "./actions";
import types from "./types";

function deleteProgramLogoRequest() {
  return {
    type: types.DELETE_PROGRAM_LOGO_REQUEST,
    isDeletingLogo: true
  };
}

function deleteProgramLogoCompleted(deletedLogo) {
  return {
    type: types.DELETE_PROGRAM_LOGO_COMPLETED,
    isDeletingLogo: false,
    deletedLogo
  };
}

function deleteProgramLogoError(logoDeleteError) {
  return {
    type: types.DELETE_PROGRAM_LOGO_ERROR,
    isDeletingLogo: false,
    logoDeleteError
  };
}

function deleteProgramFileRequest() {
  return {
    type: types.DELETE_PROGRAM_FILE_REQUEST,
    isDeletingProgramFile: true
  };
}

function deleteProgramFileCompleted(deletedProgramFile) {
  return {
    type: types.DELETE_PROGRAM_FILE_COMPLETED,
    isDeletingProgramFile: false,
    deletedProgramFile
  };
}

function deleteProgramFileError(fileDeleteError) {
  return {
    type: types.DELETE_PROGRAM_FILE_ERROR,
    isDeletingProgramFile: false,
    fileDeleteError
  };
}

function deleteCertificateRequest() {
  return {
    type: types.DELETE_CERTIFICATE_FILE_REQUEST,
    isDeletingCertificate: true
  };
}

function deleteCertificateCompleted(deletedCertificate) {
  return {
    type: types.DELETE_CERTIFICATE_FILE_COMPLETED,
    isDeletingCertificate: false,
    deletedCertificate
  };
}

function deleteCertificateError(certDeleteError) {
  return {
    type: types.DELETE_CERTIFICATE_FILE_ERROR,
    isDeletingCertificate: false,
    certDeleteError
  };
}

export function deleteProgramLogo(id) {
  return (dispatch) => {
    dispatch(deleteProgramLogoRequest());
    return api
      .deleteLogo(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteProgramLogoCompleted(response.data));
          dispatch(getFullProgram(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(deleteProgramLogoError(message));
        } else {
          logError(err);
          dispatch(deleteProgramLogoError(createError("Не удалось отправить запрос на удаление изображения программы")));
        }
      });
  };
}

export function deleteProgramFile(id) {
  return (dispatch) => {
    dispatch(deleteProgramFileRequest());
    return api
      .deleteDocument(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteProgramFileCompleted(response.data));
          dispatch(getFullProgram(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(deleteProgramFileError(message));
        } else {
          logError(err);
          dispatch(deleteProgramFileError(createError("Не удалось отправить запрос на удаление файла программы")));
        }
      });
  };
}

export function deleteCertificate(id) {
  return (dispatch) => {
    dispatch(deleteCertificateRequest());
    return api
      .deleteCertificate(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteCertificateCompleted(response.data));
          dispatch(getFullProgram(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(deleteCertificateError(message));
        } else {
          logError(err);
          dispatch(deleteCertificateError(createError("Не удалось отправить запрос на удаление файла сертификата")));
        }
      });
  };
}

function deleteProgramRequest() {
  return {
    type: types.DELETE_PROGRAM_REQUEST,
    isDeletingProgram: true
  };
}

function deleteProgramCompleted(deletedProgram) {
  return {
    type: types.DELETE_PROGRAM_COMPLETED,
    isDeletingProgram: false,
    deletedProgram
  };
}

function deleteProgramError(programDeleteError) {
  return {
    type: types.DELETE_PROGRAM_ERROR,
    isDeletingProgram: false,
    programDeleteError
  };
}

export function deleteProgram(id) {
  return (dispatch) => {
    dispatch(deleteProgramRequest());
    return api.deleteProgram(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteProgramCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(deleteProgramError(message));
        } else {
          logError(err);
          dispatch(deleteProgramError(createError("Не удалось отправить запрос на удаление программы")));
        }
      });
  };
}

export default {
  deleteProgramLogo,
  deleteProgramFile,
  deleteCertificate,
  deleteProgram
}
